import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import type { ReactNode } from 'react';

const Card = ({
  title,
  titleElement,
  children,
  error,
}: {
  title: string;
  titleElement?: React.ReactNode;
  children: ReactNode;
  error?: boolean;
}) => {
  return (
    <div className='rounded-md bg-white w-full min-w-0 border h-full'>
      <div className='flex justify-between items-center border-b-2 border-gray-200 py-3'>
        <div className='flex justify-between items-center'>
          <h3 className='font-bold text-bold border-l-4 p-4 border-green-500 capitalize md:text-sm xl:text-lg'>{title}</h3>
        </div>
        <div className='pr-4 text-green-500 hover:text-green-600 cursor-pointer' id={title}>
          {titleElement}
        </div>
      </div>
      {!error && children}
      {error && (
        <div className='text-neutralColor-normal flex flex-col items-center gap-4 justify-center mx-auto w-11/12 md:w-2/3 lg:w-3/5 max-w-lg p-6'>
          <span className='bg-red-100 rounded-full p-2'>
            <ExclamationCircleIcon className='h-5 w-5 lg:h-6 lg:w-6 text-tertiaryColor-normal' />
          </span>
          <div className='flex flex-col justify-center text-center'>
            <p className='mb-5'>Uh oh! There was some error trying to load your data. Please try again</p>
          </div>
        </div>
      )}
    </div>
  );
};
export default Card;
